<template>
  <div class="page-view pt-4 pb-4">
    <div class="container">
      <div class="clearfix"></div>      
      <div class="row">
        <div class="col-md-12">          
          <h3>
            <div class="tabs-prd-title">
              <span v-if="page" v-html="parse(page.title)"></span>
            </div>            
          </h3>           
          <div v-if="page" v-html="parse(page.body)"></div>
        </div>
        
        
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_PAGE } from '@/store/actions.type';
import util from "@/common/util";
import store from "@/store";
import RwvLatestNews from "@/components/LatestNews";

export default {
  name: "RwvTechnical",
  components: {
    RwvLatestNews
  },
  slug: {
      type: String,
      required: true
    },
  beforeRouteEnter(to, from, next) {
    Promise.all([
      store.dispatch(FETCH_PAGE, to.params.slug)
    ]).then(() => {
      next();
    });
  },
  computed: {
    ...mapGetters(["page"])
  },
  methods: {
    parse(body) {
      return body ? util.parseMarkdown(body) : "";
    }
  },
  watch: {
    $route(to) {
       store.dispatch(FETCH_PAGE, to.params.slug);
    }
  }
};
</script>
